import { render, staticRenderFns } from "./PolicyTagLink.vue?vue&type=template&id=10d269ae&scoped=true"
import script from "./PolicyTagLink.vue?vue&type=script&lang=ts"
export * from "./PolicyTagLink.vue?vue&type=script&lang=ts"
import style0 from "./PolicyTagLink.vue?vue&type=style&index=0&id=10d269ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10d269ae",
  null
  
)

export default component.exports